(function () {
  if (window.MN3_READY) return;
  window.MN3_READY = true;

  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function initHero(root) {
    var slides = $all(root, '[data-mn3-slide]');
    var n = slides.length;
    var dots = $all(root, '[data-mn3-dot]');
    var i = 0;
    function show(k) {
      i = (k + n) % n;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
      dots.forEach(function (d, j) { var on = (j % n) === i; d.classList.toggle('is-active', on); d.setAttribute('aria-current', on ? 'true' : 'false'); });
    }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j % n); }); });
    $all(root, '[data-mn3-prev]').forEach(function (b) { b.addEventListener('click', function () { show(i - 1); }); });
    $all(root, '[data-mn3-next]').forEach(function (b) { b.addEventListener('click', function () { show(i + 1); }); });
  }

  function initTabs(root) {
    var tabs = $all(root, '[data-mn3-tab]');
    var panels = $all(root, '[data-mn3-panel]');
    var all = root.querySelector('[data-mn3-all]');
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.setAttribute('aria-selected', j === k ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = j !== k; });
        if (all && t.getAttribute('data-url')) all.setAttribute('href', t.getAttribute('data-url'));
      });
    });
  }

  function initLook(root) {
    var hs = $all(root, '[data-mn3-hs]');
    var rows = $all(root, '[data-mn3-row]');
    hs.forEach(function (h, k) {
      h.addEventListener('click', function () {
        hs.forEach(function (x, j) { x.classList.toggle('is-active', j === k); });
        rows.forEach(function (r, j) { r.classList.toggle('is-active', j === k); });
      });
    });
  }

  var sheet;
  function buildSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'mn3 mn3-sheet';
    sheet.innerHTML = '<div class="mn3-sheet__scrim" data-close></div><div class="mn3-sheet__panel" role="dialog" aria-modal="true" aria-label="Größe wählen"><div class="mn3-sheet__top"><img alt=""><div class="mn3-sheet__name"><span data-title></span><strong data-price></strong></div><button type="button" class="mn3-sheet__close" data-close aria-label="Schließen">×</button></div><strong style="font-size:14px">Größe wählen</strong><div class="mn3-sheet__sizes" data-sizes></div><p class="mn3-sheet__msg" data-msg>Oversized Schnitt · Tippe auf eine Größe, der Artikel landet direkt im Warenkorb.</p></div>';
    document.body.appendChild(sheet);
    $all(sheet, '[data-close]').forEach(function (c) { c.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    return sheet;
  }
  function closeSheet() { if (sheet) sheet.classList.remove('is-open'); }

  function addToCart(id, msgEl) {
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    try { if (drawer && drawer.getSectionsToRender) sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state && state.status) { if (msgEl) msgEl.textContent = state.description || 'Das hat nicht geklappt.'; return; }
      closeSheet();
      try {
        if (drawer && drawer.renderContents && state.sections) { drawer.renderContents(state); return; }
        if (drawer && drawer.open) { drawer.open(); return; }
      } catch (e) {}
      window.location.href = root + 'cart';
    }).catch(function () { window.location.href = root + 'cart'; });
  }

  function openQuick(btn) {
    var holder = btn.closest('[data-mn3-product]');
    var dataEl = holder && holder.querySelector('script[data-mn3-variants]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var list = data.variants.filter(function (v) { return !data.color || v.c === data.color; });
    if (list.length <= 1) { var only = list[0] || data.variants[0]; if (only && only.a) addToCart(only.id); return; }
    var s = buildSheet();
    s.querySelector('img').src = data.img || '';
    s.querySelector('[data-title]').textContent = data.title;
    s.querySelector('[data-price]').textContent = data.price;
    var msg = s.querySelector('[data-msg]');
    var box = s.querySelector('[data-sizes]');
    box.innerHTML = '';
    list.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mn3-sheet__size';
      b.textContent = v.s;
      if (!v.a) { b.disabled = true; b.setAttribute('aria-label', v.s + ' ausverkauft'); }
      b.addEventListener('click', function () { b.disabled = true; addToCart(v.id, msg); });
      box.appendChild(b);
    });
    s.classList.add('is-open');
    var first = box.querySelector('button:not([disabled])');
    if (first) first.focus();
  }

  function init(scope) {
    var root = scope || document;
    $all(root, '[data-mn3-hero]').forEach(function (el) { if (!el.dataset.mn3Init) { el.dataset.mn3Init = '1'; initHero(el); } });
    $all(root, '[data-mn3-tabs]').forEach(function (el) { if (!el.dataset.mn3Init) { el.dataset.mn3Init = '1'; initTabs(el); } });
    $all(root, '[data-mn3-look]').forEach(function (el) { if (!el.dataset.mn3Init) { el.dataset.mn3Init = '1'; initLook(el); } });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mn3-quick]');
    if (btn) { e.preventDefault(); openQuick(btn); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
